import React from 'react'
import css from './TrayRankingStatusChip.module.scss'
import BothWayArrow from '../Icons/BothWayArrow'

interface TrayRankingStatusChipProps {
  status: boolean | string
}

const TrayRankingStatusChip = ({ status }: TrayRankingStatusChipProps): React.JSX.Element => {
  const isEnabled = status === true || status === 'enabled' || status === 'true'
  return (
    <span className={`${css.chip} ${isEnabled ? css.enabled : css.disabled}`}>
      <BothWayArrow />
      {isEnabled ? 'Enabled' : 'Disabled'}
    </span>
  )
}

export default TrayRankingStatusChip
